import template from './knob.tpl';
import DomUtil from '@/core/utils/domUtil';

import {Draggable} from 'gsap/Draggable';
// needed to enable this in greensock draggable
const MIN_ROTATION = -15;
const MAX_ROTATION = 285;
import knob from '@/assets/images/zeiger.svg?raw';
import styles from './knob.module.scss';
import {gsap} from 'gsap';
import AppStateModel from "@/app/model/appStateModel";

gsap.registerPlugin(Draggable);

export default class Knob {
    private minimum: number;
    private maximum: number;
    private _onChangeCallBack: ((value: number) => void) | null = null;
    public element: HTMLElement | null = null;
    private svg: SVGElement | null = null;
    private _target: HTMLElement | null = null;

    constructor(minimum = 0, maximum = 100) {

        let assets: any = {};
        assets.knob = knob;
        this.minimum = minimum;
        this.maximum = maximum;
        this._onChangeCallBack = null;

        this.element = document.createElement('div');
        this.element.innerHTML = template({styles: styles, assets: assets});
        this.element = this.element.firstChild as HTMLElement;
        (this.element?.querySelector('svg') as SVGElement).classList.add(AppStateModel.gender);

        this.svg = null;
    }


    destroy() {
        if (this._target && this.element && DomUtil.isDescendant(this._target, this.element)) {
            this._target.removeChild(this.element);
        }
        this.element = null;
    }


    appendTo(target: HTMLElement) {
        this._target = target;
        if (this.element) {
            this._target.appendChild(this.element);
        }

        let rotationOpts = {
            type: 'rotation',
            liveSnap: (value: number) => this.onSnap(value),
        };

        // init greensock draggable
        this.svg = this.element?.querySelector('svg') as SVGElement;

        if (this.svg) {
            gsap.set(this.svg, {rotation: MIN_ROTATION});
            Draggable.create(this.svg, rotationOpts as any);
        }
    }


    onSnap(endValue: number): number {
        if (endValue < MIN_ROTATION) {
            return MIN_ROTATION;
        } else if (endValue > MAX_ROTATION) {
            return MAX_ROTATION;
        }
        //endValue = Math.round(endValue);

        if (this._onChangeCallBack) {
            this._onChangeCallBack(this.getValueFromRotation(endValue));

        }
        return endValue;
    }


    setOnChangeCallback(callback: (value: number) => void) {
        this._onChangeCallBack = callback;

    }

    getValueFromRotation(rotation: number): number {
        let maxSteps = this.maximum - this.minimum;
        return Math.round(((rotation - MIN_ROTATION) * maxSteps) / (MAX_ROTATION - MIN_ROTATION) + this.minimum);
    }

    getRotationFromValue(value: number): number {
        let maxSteps = this.maximum - this.minimum;
        return ((value - this.minimum ) * (MAX_ROTATION - MIN_ROTATION)) / maxSteps + MIN_ROTATION;
    }

    getRotation(): number {
        if (this.svg) {
            const element = Draggable.get(this.svg);
            return element.rotation;
        }
        return 0;
    }

    set inputValue(value: number) {
        if (this.svg) {
            gsap.set(this.svg, {rotation: this.getRotationFromValue(value)});
        }
    }

    updateByMousePosition(x: number, y: number) {
        if (!this.svg) return;

        let rect = this.svg.getBoundingClientRect();
        let centerX = rect.left + (rect.right-rect.left)/2;
        let centerY = rect.top + (rect.bottom-rect.top)/2;

        let lx = centerX - x;
        let ly = centerY - y;

        var a = Math.atan2(ly, lx) / ( Math.PI / 180);
        this._rotateTo(a+45);
    }

    _rotateTo(a: number) {
        if( a < -60) {
            a = 360 +a;
        }
        if (a < MIN_ROTATION) {
            a = MIN_ROTATION;
        } else if (a > MAX_ROTATION) {
            a = MAX_ROTATION;
        }

        if (this._onChangeCallBack) {
            this._onChangeCallBack(this.getValueFromRotation(a));
        }
    }

}
